<div class="container-fluid mt-5">
  <div class="row  mt-2 align-center main-router mt-5">
    <div class="container  mt-5">
      <div class="list-group-item">
       <!--  <h2 class="blue">Payment Receipt of Worker Registration under BOCW Act</h2> -->
        <table class="table">
          <!-- 

        receiptData={
        name:d.WRG_Name,
        fname:d.WRG_FatherName,
        dob:d.WRG_DOB,
        fromD:d.WC_StartDate.substr(0,10),
        toD:d.WC_EndDate.substr(0,10),
        Address:d.WRG_Address,
        pmthd:d.WC_PaymentThrough,
        fileNo:d.WC_WorkerRegno,
        circle:d.circle,
        subdiv:d.subdiv,
        transNo:d.WC_TransNo,
        BnkRef:d.WC_BankRefNo,
        feePaid:d.WC_AmountPay
      }


     -->
          <tbody>
            <tr>
              <td class="text-center right" colspan="6">
                <h4>Office Copy</h4>
                <p>(Payment Receipt of Registration of Construction worker under The BOCW Act, 1996)</p>
              </td>
            </tr>
            <tr>
              <th class="blue width">Name: </th>
              <td>{{receiptData.name}}</td>
              <th class="blue width">S/o,D/o,W/o: </th>
              <td colspan="2">{{receiptData.fname}}</td>
              <td style="width: 20%" class="right qr" rowspan="3">
                <qrcode [qrdata]="jsonData" [size]="126" [colordark]="'#223C7B'" [level]="'Q'"></qrcode>
              </td>
            </tr>
            <tr>
              <th class="blue width">From: </th>
              <td>{{CSF.dateToYYMMDD(receiptData.fromD)}}</td>
              <th class="blue width">To: </th>
              <td colspan="2">{{CSF.dateToYYMMDD(receiptData.toD)}}</td>
            </tr>
            <tr>
              <th class="blue width">Date of Birth: </th>
              <td>{{CSF.dateToYYMMDD(receiptData.dob)}}</td>
              <th class="blue width">No. of Years: </th>
              <td colspan="2" class="right">{{receiptData.years}}</td>
            </tr>
            <tr>
              <th colspan=1 class="blue width">Address: </th>
              <td class="right" colspan=5> {{receiptData.Address}} </td>
            </tr>
            <tr>
              <th class="blue width"> Payment Method:</th>
              <td colspan="1">{{receiptData.pmthd}}</td>
              <th class="blue width">File No.:</th>
              <td class="right" colspan="3">{{receiptData.fileNo}}</td>
            </tr>
            <tr>
              <th class="blue width">Circle:</th>
              <td colspan="1" class="">{{receiptData.circle}}</td>
              <th class="blue width">Area Inspector:</th>
              <td colspan="3" class="right">{{receiptData.subdiv}}</td>
            </tr>
            <tr>
              <th colspan=1 class="blue width">Draft No/ Payment Transection No.: </th>
              <td colspan=1>{{receiptData.transNo}}</td>
              <th colspan=1 class="blue width" *ngIf="receiptData.pmthd=='Online'"> Bank Refence No.: </th>
              <td class="right" colspan=3>{{receiptData.BnkRef}}</td>
            </tr>
            <tr>
              <th class="blue  width">Payment Date: </th>
              <td>{{receiptData.paydate}}</td>
              <th class="blue  width">Status</th>
              <td>Payment Submitted Successfully</td>
              <th class="blue text-right width">Total Fee Paid: </th>
              <td class="right blue text-right"><strong>Rs. {{receiptData.feePaid}}</strong></td>
            </tr>
            <tr>

              <td class="text-center right" colspan="6">
                <hr style="border: 0;  border-top: 2px dotted #8c8c8c;">
                <h4>Worker Copy</h4>
                <p>(Payment Receipt of Registration of Construction worker under The BOCW Act, 1996)</p>
              </td>
            </tr>
            <tr>
              <th class="blue width">Name: </th>
              <td>{{receiptData.name}}</td>
              <th class="blue width">S/o,D/o,W/o: </th>
              <td colspan="2">{{receiptData.fname}}</td>
              <td style="width: 20%" class="right qr" rowspan="3">
                <qrcode [qrdata]="jsonData" [size]="126" [colordark]="'#223C7B'" [level]="'Q'"></qrcode>
              </td>
            </tr>
            <tr>
              <th class="blue width">From: </th>
              <td>{{CSF.dateToYYMMDD(receiptData.fromD)}}</td>
              <th class="blue width">To: </th>
              <td colspan="2">{{CSF.dateToYYMMDD(receiptData.toD)}}</td>
            </tr>
            <tr>
              <th class="blue width">Date of Birth: </th>
              <td>{{CSF.dateToYYMMDD(receiptData.dob)}}</td>
              <th class="blue width">No. of Years: </th>
              <td colspan="2" class="right">{{receiptData.years}}</td>
            </tr>
            <tr>
              <th colspan=1 class="blue width">Address: </th>
              <td class="right" colspan=5> {{receiptData.Address}} </td>
            </tr>
            <tr>
              <th class="blue width"> Payment Method:</th>
              <td colspan="1">{{receiptData.pmthd}}</td>
              <th class="blue width">File No.:</th>
              <td class="right" colspan="3">{{receiptData.fileNo}}</td>
            </tr>
            <tr>
              <th class="blue width">Circle:</th>
              <td colspan="1" class="">{{receiptData.circle}}</td>
              <th class="blue width">Area Inspector:</th>
              <td colspan="3" class="right">{{receiptData.subdiv}}</td>
            </tr>
            <tr>
              <th colspan=1 class="blue width">Draft No/ Payment Transection No.: </th>
              <td colspan=1>{{receiptData.transNo}}</td>
              <th colspan=1 class="blue width" *ngIf="receiptData.pmthd=='Online'"> Bank Refence No.: </th>
              <td class="right" colspan=3>{{receiptData.BnkRef}}</td>
            </tr>
            <tr>
              <th class="blue  width">Payment Date: </th>
              <td>{{receiptData.paydate}}</td>
              <th class="blue  width">Status</th>
              <td>Payment Submitted Successfully</td>
              <th class="blue text-right width">Total Fee Paid: </th>
              <td class="right blue text-right"><strong>Rs. {{receiptData.feePaid}}</strong></td>
            </tr>
            <tr>
              <td class="text-center right" colspan="6"><a routerLink="/" class="btn" *ngIf="userRole!='sewakendra'">Back </a> <a (click)="goBackESewa()" class="btn" *ngIf="userRole=='sewakendra'">Go Back To Esewa </a></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
